import React from 'react';
import { motion } from 'framer-motion';
import { Map, Target, Rocket } from 'lucide-react';
export function Slide12NextSteps() {
  const steps = [{
    num: '01',
    title: 'Map the journey',
    desc: 'Identify the congress stages and likely engagement bottlenecks.',
    icon: Map
  }, {
    num: '02',
    title: 'Choose the use case',
    desc: 'Select one pilot that is valuable, practical and easy to approve internally.',
    icon: Target
  }, {
    num: '03',
    title: 'Launch, learn and expand',
    desc: 'Deploy the Snak, collect data and recommend the next step based on results.',
    icon: Rocket
  }];
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-12 md:px-24 md:pt-20 md:pb-28 relative overflow-hidden" data-id="element-65">
      <header className="mb-10" data-id="element-66">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-4" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-67">
          Suggested next step:{' '}
          <span className="text-[#E60012]" data-id="element-68">map, choose, pilot.</span>
        </motion.h2>
        <motion.p className="text-xl text-[#4A5568] font-light max-w-3xl" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-69">
          Once Takeda shares the campaign briefing materials, Snakker can
          recommend the strongest first use case.
        </motion.p>
      </header>

      <main className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto w-full" data-id="element-70">
        {steps.map((step, index) => {
        const Icon = step.icon;
        return <motion.div key={step.num} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 relative overflow-hidden flex flex-col justify-center hover:shadow-md transition-shadow" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3 + index * 0.15
        }} data-id="element-71">
              <div className="absolute -top-4 -right-2 text-8xl font-bold text-gray-100 pointer-events-none select-none" data-id="element-72">
                {step.num}
              </div>

              <div className="w-14 h-14 rounded-xl bg-[#E60012]/10 flex items-center justify-center mb-6 relative z-10" data-id="element-73">
                <Icon className="w-7 h-7 text-[#E60012]" data-id="element-74" />
              </div>

              <h3 className="text-2xl font-bold text-[#1A202C] mb-4 relative z-10" data-id="element-75">
                {step.title}
              </h3>
              <p className="text-[#4A5568] leading-relaxed relative z-10" data-id="element-76">
                {step.desc}
              </p>
            </motion.div>;
      })}
      </main>

      <motion.footer className="mt-10 pt-8 border-t border-gray-200 flex flex-col items-center text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.8,
      delay: 1
    }} data-id="element-77">
        <p className="text-[#4A5568] mb-3" data-id="element-78">
          Snakker helps Takeda turn congress activity into a measurable
          engagement journey, one focused use case at a time.
        </p>
        <p className="text-2xl font-bold text-[#1A202C]" data-id="element-79">
          Map the full congress journey.{' '}
          <span className="text-[#E60012]" data-id="element-80">Start with one bottleneck.</span>
        </p>
      </motion.footer>
    </div>;
}